import React from "react";
import { Skeleton, Stack } from "@mui/material";

export const TableSkeleton = ({
  rows = 10,
  headerHeight = 35,
  rowHeight = 51,
}) => {
  const sx = {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    "&:after": {
      background:
        "linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.15), transparent)",
    },
  };
  return (
    <Stack gap="2px" height="100%">
      <Skeleton variant="rounded" height={headerHeight} sx={sx} />
      <Stack gap="2px">
        {Array.from(new Array(rows)).map((_, rowIndex) => (
          <Skeleton variant="rounded" height={rowHeight} sx={sx} />
        ))}
      </Stack>
    </Stack>
  );
};

export default TableSkeleton;
